import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { addData, editData, getList } from '../../helpers/fackBackend_Helper';

function* addChatrBulkActivationResponse({ payload: { data, searchData } }) {
    try {
        const response = yield call(addData, '/createChatrBulkActivationRequest', data);
        if (response.Status) {
            yield put(actions.addChatrBulkActivationSuccess(response.Message));
            yield put(actions.getChatrActivationRequestList(searchData));
        } else {
            yield put(actions.addChatrBulkActivationFailed(response.Message));
            yield put(actions.getChatrActivationRequestList(searchData));
        }
    } catch (error) {
        yield put(actions.addChatrBulkActivationFailed(error));
    }
}

function* getChatrActivationRequestResponse({ payload: { searchData } }) {
    try {
        const response = yield call(addData, '/chatrActivationRequestList', searchData);
        if (response?.response?.Status) {
            yield put(actions.getChatrActivationRequestListSuccessful(response?.response?.data));
        } else {
            yield put(actions.getChatrActivationRequestListFailed(response?.response?.Message));
        }
    } catch (error) {
        yield put(actions.getChatrActivationRequestListFailed(error));
    }
}

function* getChatrBatchTransactionIdResponse({ payload: { data } }) {
    try {
        const response = yield call(getList, `/getChatrActivationBatchData/${data.batchID}`,);
        if (response.response?.Status) {
            yield put(actions.getChatrBatchTransactionIdRequestSuccessful(response.response.Data,),);
        } else {
            yield put(actions.getChatrBatchTransactionIdRequestFailed(response.response.Message,),);
        }
    } catch (error) {
        yield put(actions.getChatrBatchTransactionIdRequestFailed(error));
    }
}

export default function* rootSaga() {
    yield all([takeEvery(actions.ADD_CHATR_BULK_ACTIVATION, addChatrBulkActivationResponse)]);
    yield all([takeEvery(actions.GET_CHATR_ACTIVATION_REQUEST_LIST, getChatrActivationRequestResponse)]);
    yield all([takeEvery(actions.GET_CHATR_BATCHTRANSACTIONBYID_REQUEST, getChatrBatchTransactionIdResponse)]);
}